/* GENERATED FILE - do not edit. Run: node scripts/generate-phosphor-icons.mjs */
import type { JSX } from 'solid-js'
import { IconBase, type IconProps, type WeightRenderers } from './IconBase'

const renderers: WeightRenderers = {
  regular: (color: string): JSX.Element => (
    <g>
      <line
        x1="40"
        y1="128"
        x2="216"
        y2="128"
        fill="none"
        stroke={color}
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="16"
      />
      <polyline
        points="144 56 216 128 144 200"
        fill="none"
        stroke={color}
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="16"
      />
    </g>
  ),
  bold: (color: string): JSX.Element => (
    <g>
      <line
        x1="40"
        y1="128"
        x2="216"
        y2="128"
        fill="none"
        stroke={color}
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="24"
      />
      <polyline
        points="144 56 216 128 144 200"
        fill="none"
        stroke={color}
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="24"
      />
    </g>
  ),
  fill: (_color: string): JSX.Element => (
    <g>
      <path d="M221.65674,133.65723l-72,72A8.00038,8.00038,0,0,1,136,200V136H40a8,8,0,0,1,0-16h96V56a8.00037,8.00037,0,0,1,13.65674-5.65723l72,72A8.00034,8.00034,0,0,1,221.65674,133.65723Z" />
    </g>
  ),
}

export const ArrowRight = (props: IconProps) => <IconBase {...props} renderers={renderers} />
